import {Stack, Typography, useTheme} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {BeneficiaryInfoProps} from './types';

const {cellphone, email} = translations['pt-br'].privateFlow.bookingFlow.confirmationDrawer;

const BeneficiaryInfo = ({
	cellPhone,
	eMail,
	hasCellPhoneWarn,
	hasEMailWarn,
}: BeneficiaryInfoProps) => {
	const {brand} = useTheme();

	return (
		<Stack direction="column" spacing={1.5}>
			<Stack direction="row" alignItems="center" spacing={2}>
				<IconIllustration
					customIconName="phone-android-filled"
					variant="primary"
					size="smaller"
				/>
				<Stack direction="column" flex={1}>
					<Typography color="text.primary" variant="label" mb={0}>
						{cellphone}
					</Typography>
					<Typography color="text.secondary" variant="body2">
						{cellPhone}
					</Typography>
				</Stack>
				{hasCellPhoneWarn ? (
					<Icon
						name="warning-outlined"
						size={16}
						color={brand.primary.lightOrange}
						style={{marginRight: 16}}
					/>
				) : null}
			</Stack>
			<Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
				<IconIllustration customIconName="mail-filled" variant="primary" size="smaller" />
				<Stack direction="column" flex={1}>
					<Typography color="text.primary" variant="label" mb={0}>
						{email}
					</Typography>
					<Typography color="text.secondary" variant="body2">
						{eMail}
					</Typography>
				</Stack>
				{hasEMailWarn ? (
					<Icon
						name="warning-outlined"
						size={16}
						color={brand.primary.lightOrange}
						style={{marginRight: 16}}
					/>
				) : null}
			</Stack>
		</Stack>
	);
};

export {BeneficiaryInfo};
